export default {
      id: "filter-usage",
      viewBox: "0 0 18 17",
      url: __webpack_public_path__ + "img/icons.479460d5.svg#filter",
      toString: function () {
        return this.url;
      }
    }